<template>
  <div>
    <template v-if="!isTablet">
      <b-popover
        target="moveBoardBtn"
        variant="light"
        triggers="click"
        placement="bottom"
      >
        <template v-slot:title>
          Selecione para qual quadro deseja mover este card
        </template>

        <section class="create__card__container pb-4">
          <div>
            <SelectBoard
              @onSelect="loadColumns"
              :onlyActive="true"
            />
          </div>
          <div>
            <SelectBoardColumn
              v-if="moveCard.boardId"
              @onSelect="saveBoardAndColumn"
              :boardId="moveCard.boardId"
              :key="moveCard.boardId"
            />
          </div>
        </section>

        <DefaultButton
          btnVariant="btn-third justify-content-center"
          :onClick="confirmSelection"
          icon="fas fa-check-circle"
          text="Salvar"
        />
      </b-popover>
    </template>
    <template v-else>
      <b-modal
        scrollable
        centered
        :visible="true"
        :hide-footer="true"
        @hide="destroyModal"
        @close="destroyModal"
      >
        <template #modal-title>
          Selecione para qual quadro deseja mover este card
        </template>

        <template v-slot:title>
          Selecione para qual quadro deseja mover este card
        </template>

        <section class="create__card__container pb-4">
          <div>
            <SelectBoard
              @onSelect="loadColumns"
              :onlyActive="true"
            />
          </div>
          <div>
            <SelectBoardColumn
              v-if="moveCard.boardId"
              @onSelect="saveBoardAndColumn"
              :boardId="moveCard.boardId"
              :key="moveCard.boardId"
            />
          </div>
        </section>

        <DefaultButton
          btnVariant="btn-third justify-content-center"
          :onClick="confirmSelection"
          icon="fas fa-check-circle"
          text="Salvar"
        />
      </b-modal>
    </template>
    <!-- <EventManager
      v-if="card.id && columnEvents"
      :key="card.id"
      ref="EventManager"
      :eventsToShow="columnEvents"
      :card="card"
      @Submited="a"
      @Aborted="b"
    ></EventManager> -->
  </div>
</template>

<script>
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
// import { toast } from '@/shared/utils/UIHelper'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import EventManager from '@/views/private/crm/board/modal/event/EventManager.vue'

export default {
  name: 'MoveCardBoardPopover',
  components: {
    DefaultButton,
    EventManager,
    SelectBoard,
    SelectBoardColumn
  },
  props: {
    card: {
      type: Object,
      required: true
    },
    oldBoardColumnId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      columnEvents: null,
      isTablet: screen.width <= 1000,
      moveCard: {
        boardId: null,
        boardColumnID: null
      }
    }
  },
  methods: {
    a () {
      console.log('enviado')
    },
    b () {
      console.log('enviado')
    },
    destroyModal () {
      this.$emit('close')
    },
    emitedFollowUp () {
      this.followupEmited = true
      this.confirmSelection()
    },
    confirmSelection () {
      this.onMoveCardBoard(this.moveCard)
    },
    onMoveCardBoard (moveCard) {
      if (moveCard) {
        BoardRepositoryV2.Column_GetById(
          moveCard.boardId,
          moveCard.boardColumnID
        )
          .then((response) => {
            if (response.data) {
              this.columnEvents = response.data.eventoColuna

              BoardRepositoryV2.Card_MoveCardBoard(
                this.card.boardColumn.board.id,
                this.card.boardColumn.id,
                this.card.id,
                moveCard
              )
                .then((response) => {
                  if (response.status === 200) {
                    this.$emit('moved', this.oldBoardColumnId)
                  }
                  // this.closeAndUpdate()
                })
                .catch(this.onException)
            }
          })
          .catch(this.onException)
      }
    },
    loadColumns (boardId) {
      this.moveCard.boardId = boardId
    },
    saveBoardAndColumn (boardAndColumn) {
      this.moveCard.boardId = boardAndColumn[0]
      this.moveCard.boardColumnID = boardAndColumn[1]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/components/moveCardBoard/moveCardBoard.vue